import {CP, initParam} from "../setting/initParam";
import {
    centeredLine, createDefaultMaterial, InitialStruct,
    matBeam, ParamsGetSimpleBoard, RenderElement,
    RenderStruct, simpleSize, Vec3
} from "@3dcalc/3dpClient";
import {api} from "../api/api";
import {InitialStructWhithBlock} from "@3dcalc/3dpClient/dist/types/types";
import {SpecStructElement, StructData} from "@3dcalc/3dpClient/dist/types/renderElements";


export async function getF2(s:InitialStructWhithBlock, sBoard:simpleSize, modeBuild: boolean = false): Promise<StructData> {

    const boardL = CP.maps.f2.param.h
        - initParam.elementData.ridge.sizeBoard.h
        + initParam.elementData.harness.sizeBoard.h
        - initParam.elementData.f1.sizeBoard.h
        - initParam.gash.rafterAngle
        + initParam.gash.simple
        + initParam.gash.simple

    initParam.elementData.f2.sizeBoard.l = boardL

    const paramsGetSimpleBoard: ParamsGetSimpleBoard = {
        modeBuild: modeBuild,
        shift: {back: 0, front: 0},
        sizeBoard: {w: sBoard.w, h: sBoard.h, l: boardL},
        cuts: [],
    }
    const rs:RenderStruct = {
        vertices: [],
        indices: [],
        uvs: [],
        material: [],
        elements: [],
        group: ''
    }
    const spec: SpecStructElement[] = []
    const specIds: string[] = []
    rs.material.push(createDefaultMaterial())
    const resultGetSimpleBoard = await api.getSimpleBoard.build(paramsGetSimpleBoard)
    rs.uvs.push(resultGetSimpleBoard.mesh.uvs)
    const numUvs = rs.uvs.length - 1
    rs.indices.push(resultGetSimpleBoard.mesh.indices)
    const numIndices = rs.indices.length - 1
    rs.vertices.push(resultGetSimpleBoard.mesh.vertices)
    const numVertices = rs.vertices.length - 1
    const nameGroup = 'F2'
    const specID = nameGroup
    rs.group = nameGroup
    const numGroups = rs.group.length
    const meta = resultGetSimpleBoard.meta

    const line = CP.maps.f1.lineCut

    const realSeg = centeredLine(CP.maps.f1.lineCut, s.l)
    for (let i = 0; i < realSeg.length - 1; i++) {
        const x = realSeg[i][0] + s.block.w / 2

        const z = s.h
            - initParam.gash.simple
            - initParam.gash.simple
            + initParam.elementData.f1.sizeBoard.h
            + boardL / 2

        const pos:Vec3 = [x, z, 0]

        // const pos = updatePosY(position[i], sBoard.l / 2)

        const board: RenderElement = {
            indices: numIndices,
            name: `${nameGroup} - ${i}`,
            nameGroup: nameGroup,
            position: pos,
            rotation: [0,0,0],
            uvs: numUvs,
            vertices: numVertices,
            material: 0,
            specId: specID
        }
        rs.elements.push(board)
    }
    spec.push({
        w: resultGetSimpleBoard.meta.w,
        h: resultGetSimpleBoard.meta.h,
        l: resultGetSimpleBoard.meta.l,
        name: "Ферма - элемент №2",
        group: specID,
        count: realSeg.length - 1,
        specId: specID
    })
    specIds.push(specID)
    rs.specIds = specIds


    return {rs: rs, spec: spec}
}
